<app-storage-input-history
  [titleKey]="titleKey"
  [noFilesKey]="noFilesKey"
  [attachments]="attachments"
  [accept]="accept"
  [filterByAccept]="filterByAccept"
  [downloadProperty]="downloadProperty"
  [onUpload]="onUpload"
  [onRemove]="onRemove"
  [isUploading]="isUploading"
  [uploadProgress]="uploadProgress"
  [uploadError]="uploadError"
  [removingIds]="removingIds"
  [removeError]="removeError"
  [hideUploadLabel]="true"
  (pathsChanged)="onPathsChanged($event)"
>
</app-storage-input-history>
